import { AutogenModelMatchTractorType, AutogenRowMatchTractorType } from "./autogen/AutogenModelMatchTractorType";

export class ModelMatchTractorType extends AutogenModelMatchTractorType<RowMatchTractorType> {
    constructor() {
        super(RowMatchTractorType);
    }
}

export class RowMatchTractorType extends AutogenRowMatchTractorType {
}